import type { CSSProperties, ReactNode } from "react"

import { cn } from "@/lib/utils"

type RevealProps = {
  children: ReactNode
  className?: string
  /** Seconds to delay the entrance, used to stagger siblings. Mount mode only. */
  delay?: number
  /** Initial vertical offset in px. */
  y?: number
  /**
   * Play on load instead of on scroll. Required above the fold: a scroll-driven
   * entrance would hold the content at opacity 0 while it is already in view.
   */
  immediate?: boolean
}

/**
 * Fade-and-rise a block into view. CSS only, so the landing page ships no
 * animation runtime and never gates a paint on hydration.
 */
export function Reveal({
  children,
  className,
  delay = 0,
  y = 16,
  immediate = false,
}: RevealProps) {
  return (
    <div
      className={cn(immediate ? "reveal-mount" : "reveal-scroll", className)}
      style={
        {
          "--reveal-y": `${y}px`,
          "--reveal-delay": delay ? `${delay}s` : undefined,
        } as CSSProperties
      }
    >
      {children}
    </div>
  )
}
